import { api } from './api';
import type {
  CreateProductModuleRequest,
  ProductModule,
  UpdateProductModuleRequest,
} from '../types/productModule';

class ProductModuleService {
  async getAll(): Promise<ProductModule[]> {
    const response = await api.get<ProductModule[]>('/product-modules');
    return response.data;
  }

  async getById(id: string): Promise<ProductModule> {
    const response = await api.get<ProductModule>(`/product-modules/${id}`);
    return response.data;
  }

  async getByCode(code: string): Promise<ProductModule> {
    const response = await api.get<ProductModule>(
      `/product-modules/code/${encodeURIComponent(code)}`
    );
    return response.data;
  }

  async create(payload: CreateProductModuleRequest): Promise<ProductModule> {
    const response = await api.post<ProductModule>('/product-modules', payload);
    return response.data;
  }

  async update(id: string, payload: UpdateProductModuleRequest): Promise<ProductModule> {
    const response = await api.put<ProductModule>(`/product-modules/${id}`, payload);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/product-modules/${id}`);
  }
}

export const productModuleService = new ProductModuleService();
